/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbox_SendInputs */

const en_inbox_send = /** @type {(inputs: Inbox_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send`)
};

const es_inbox_send = /** @type {(inputs: Inbox_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar`)
};

const fr_inbox_send = /** @type {(inputs: Inbox_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envoyer`)
};

const de_inbox_send = /** @type {(inputs: Inbox_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senden`)
};

const ja_inbox_send = /** @type {(inputs: Inbox_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`送信`)
};

const zh_inbox_send = /** @type {(inputs: Inbox_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发送`)
};

const ar_inbox_send = /** @type {(inputs: Inbox_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إرسال`)
};

const id_inbox_send = /** @type {(inputs: Inbox_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kirim`)
};

const it_inbox_send = /** @type {(inputs: Inbox_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invia`)
};

const ru_inbox_send = /** @type {(inputs: Inbox_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отправить`)
};

const pt_inbox_send = /** @type {(inputs: Inbox_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar`)
};

const ko_inbox_send = /** @type {(inputs: Inbox_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`전송`)
};

/**
* | output |
* | --- |
* | "Send" |
*
* @param {Inbox_SendInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const inbox_send = /** @type {((inputs?: Inbox_SendInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_SendInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_inbox_send(inputs)
	if (locale === "es") return es_inbox_send(inputs)
	if (locale === "fr") return fr_inbox_send(inputs)
	if (locale === "de") return de_inbox_send(inputs)
	if (locale === "ja") return ja_inbox_send(inputs)
	if (locale === "zh") return zh_inbox_send(inputs)
	if (locale === "ar") return ar_inbox_send(inputs)
	if (locale === "id") return id_inbox_send(inputs)
	if (locale === "it") return it_inbox_send(inputs)
	if (locale === "ru") return ru_inbox_send(inputs)
	if (locale === "pt") return pt_inbox_send(inputs)
	return ko_inbox_send(inputs)
});